// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-pagination__list {
  display: inline-flex;
  list-style-type: none;
  justify-content: center;
  width: 100%;
}
:where(.vuetify-styles) .v-pagination__item, :where(.vuetify-styles) .v-pagination__first, :where(.vuetify-styles) .v-pagination__prev, :where(.vuetify-styles) .v-pagination__next, :where(.vuetify-styles) .v-pagination__last {
  margin: 0.3rem;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VPagination/VPagination.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;AAChB","sourcesContent":[".v-pagination__list {\n  display: inline-flex;\n  list-style-type: none;\n  justify-content: center;\n  width: 100%;\n}\n.v-pagination__item, .v-pagination__first, .v-pagination__prev, .v-pagination__next, .v-pagination__last {\n  margin: 0.3rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
